export const SELECTED_DEFECT_SEARCH_PARAM = 'defect';
